import { Component, computed, inject } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [CommonModule, DropdownComponent],
})
export class UserDropdownComponent {
  private auth = inject(AuthService);

  isOpen = false;
  user = this.auth.user;
  displayName = computed(() => {
    const user = this.user();

    return user?.username || this.emailName(user?.userEmailAddress) || 'User';
  });
  email = computed(() => this.user()?.userEmailAddress || '');

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  logout() {
    this.closeDropdown();
    this.auth.logout();
  }

  private emailName(email: string | null | undefined) {
    return email?.split('@')[0] ?? '';
  }
}
